/**
 * Hinweis-/Fehlerfläche. Markup unverändert aus Preline, nur Texte ersetzt.
 * Ton = feste, vollständige Klassenketten je Variante (nie zusammengesetzt).
 *
 * Fehler und Warnungen (Ablehnung/Fehlschlag, r105; Ton „warnung“ ist die Fläche des Fehlschlags am Feld und im
 * Dialog, M-002 F4) tragen role="alert" und werden sofort vorgelesen (Betreiber 06.10.2026, W36 b); Info, Erfolg
 * und neutrale Hinweise role="status" (Plan Regel 8). Der Satz kommt immer vom Aufrufer, nie ein roher Fehlercode.
 */
export type AlertTon = "fehler" | "warnung" | "info" | "erfolg" | "neutral";

const TON_KLASSEN: Record<AlertTon, string> = {
  fehler: "bg-red-100 border border-red-200 text-sm text-red-800 rounded-lg p-4",
  warnung: "bg-yellow-100 border border-yellow-200 text-sm text-yellow-800 rounded-lg p-4",
  info: "bg-primary-100 border border-primary-200 text-sm text-primary-800 rounded-lg p-4",
  erfolg: "bg-teal-100 border border-teal-200 text-sm text-teal-800 rounded-lg p-4",
  neutral: "bg-muted border border-line-2 text-sm text-foreground rounded-lg p-4",
};

export function Alert({
  ton,
  titel,
  children,
  id,
}: {
  ton: AlertTon;
  /** Fett gesetzter Einstieg (optional). */
  titel?: string;
  children?: React.ReactNode;
  /** Eindeutige Id für aria-labelledby (Pflicht, wenn titel gesetzt). */
  id?: string;
}) {
  const role = ton === "fehler" || ton === "warnung" ? "alert" : "status";
  const labelId = titel && id ? `${id}-label` : undefined;
  return (
    <>
      {/* Preline: component/alerts/alerts-soft-color-variants */}
      <div id={id} className={TON_KLASSEN[ton]} role={role} tabIndex={-1} aria-labelledby={labelId}>
        {titel && (
          <span id={labelId} className="font-bold">
            {titel}
          </span>
        )}
        {titel && children ? " " : null}
        {children}
      </div>
    </>
  );
}
